import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Inject,
} from '@angular/core';
import { CustomWindow } from 'libs/self-fix/feature-components/src/lib/components/footer/custom-window.interface';
import { DatePipe, NgIf } from '@angular/common';
import { NgFor } from '@angular/common';
import { AppEnvironment } from 'apps/dg-self-fix/src/app/models/environment/app-environment.type';
import { ENVIRONMENT } from '@domgen/dgx-fe-config';

interface Link {
  link: string;
  url: string;
}

declare let window: CustomWindow;

@Component({
  selector: 'smart-fix-hub-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [DatePipe, NgFor, NgIf],
})
export class SmartFixHubFooterComponent implements AfterViewInit {
  primaryLinks: Link[] = [
    {
      link: 'About us',
      url: 'https://www.domesticandgeneral.com/corporate/about-us',
    },
    {
      link: 'Help and advice',
      url: 'https://www.domesticandgeneral.com/content/help-advice-section/faq',
    },
    {
      link: 'Contact us',
      url: 'https://www.domesticandgeneral.com/content/contact-domestic-general',
    },
  ];

  secondaryLinks: Link[] = [
    {
      link: 'Website Terms and Conditions',
      url: 'https://www.domesticandgeneral.com/web-terms-conditions',
    },
    {
      link: 'Privacy and Cookies policy',
      url: 'https://www.domesticandgeneral.com/privacy-cookies-policy',
    },
    {
      link: 'Accessibility policy',
      url: 'https://www.domesticandgeneral.com/accessibility',
    },
  ];

  @ViewChild('Trustpilot', { static: false }) Trustpilot!: ElementRef;

  public date = Date.now();

  constructor(
    @Inject(ENVIRONMENT) public readonly environment: AppEnvironment
  ) {}

  ngAfterViewInit() {
    if (window['Trustpilot']) {
      window.Trustpilot.loadFromElement(this.Trustpilot?.nativeElement);
    }
  }
}
